<template>
  <div id="lanch" @click="triggerIntercom">
    <div v-if="loading" class="spinner"></div>
    <SvgIcon
      v-else
      :iconContent="iconContent"
      :iconAlt="iconAlt"
      :iconStyle="iconStyle"
    />
    <!-- <SvgIcon
      :iconContent="iconContent"
      :iconAlt="iconAlt"
      :iconStyle="iconStyle"
    /> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { SvgIcon } from "@/components/index";
import headset from "@/assets/images/svg/headset.svg";
import { initializeIntercomWithCompanyData } from "@/utils/helpers/store";
import { LogLevel, LogService } from "@/services/logging";
import { ref } from "vue";
export default defineComponent({
  name: "Intercom",
  components: {
    SvgIcon,
  },
  setup() {
    const iconStyle = "filter: contrast(170%) invert(100%);";

    const iconContent = headset;
    const iconAlt = "Contact Support";
    const loading = ref(false);

    //
    async function triggerIntercom() {
      if (loading.value) return; // prevent double clicks

      loading.value = true;
      try {
        if (window.Intercom) {
          LogService.info(`Intercom already initialized, lets show it`);
          console.log("------- Intercom already initialized, lets show it");
          // If Intercom is already initialized, just show it
          // @ts-ignore
          window.Intercom("open");
          LogService.info(`Intercom chatbot is now shown`);
        } else {
          // Initialize Intercom if not already initialized
          LogService.info(`Initialize Intercom if not already initialized`);
          await initializeIntercomWithCompanyData();
          LogService.info(`Intercom is now initialized, lets show the chatbot`);
          // Show the Intercom widget
          // await new Promise((resolve) => setTimeout(resolve, 100));
          console.log("------ showing chatbot");
          // @ts-ignore
          window.Intercom("show");
          LogService.info(`Intercom chatbot is now shown`);
        }
      } catch (error) {
        console.error("Error triggering Intercom:", error);
        LogService.info(
          `Error triggering Intercom`,
          { param: { error } },
          LogLevel.Error
        );
      } finally {
        loading.value = false;
      }
    }

    return {
      iconContent,
      iconAlt,
      iconStyle,
      triggerIntercom,
      loading,
    };
  },
});
</script>
<style scoped>
#lanch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 40px;
  height: 40px;
  position: relative;
}

/* Spinner Style */
.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid transparent;
  border-top: 3px solid white;
  border-radius: 50%;
  background-color: transparent;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
